export default [
    { alpha2: 'AF', name: 'Afghanistan', dial_code: '+93' },
    { alpha2: 'AL', name: 'Albania', dial_code: '+355' },
    { alpha2: 'DZ', name: 'Algeria', dial_code: '+213' },
    { alpha2: 'AS', name: 'American Samoa', dial_code: '+1684' },
    { alpha2: 'AD', name: 'Andorra', dial_code: '+376' },
    { alpha2: 'AO', name: 'Angola', dial_code: '+244' },
    { alpha2: 'AI', name: 'Anguilla', dial_code: '+1264' },
    { alpha2: 'AG', name: 'Antigua and Barbuda', dial_code: '+1268' },
    { alpha2: 'AR', name: 'Argentina', dial_code: '+54' },
    { alpha2: 'AM', name: 'Armenia', dial_code: '+374' },
    { alpha2: 'AW', name: 'Aruba', dial_code: '+297' },
    { alpha2: 'AU', name: 'Australia', dial_code: '+61' },
    { alpha2: 'AT', name: 'Austria', dial_code: '+43' },
    { alpha2: 'AZ', name: 'Azerbaijan', dial_code: '+994' },
    { alpha2: 'BS', name: 'Bahamas', dial_code: '+1242' },
    { alpha2: 'BH', name: 'Bahrain', dial_code: '+973' },
    { alpha2: 'BD', name: 'Bangladesh', dial_code: '+880' },
    { alpha2: 'BB', name: 'Barbados', dial_code: '+1246' },
    { alpha2: 'BY', name: 'Belarus', dial_code: '+375' },
    { alpha2: 'BE', name: 'Belgium', dial_code: '+32' },
    { alpha2: 'BZ', name: 'Belize', dial_code: '+501' },
    { alpha2: 'BJ', name: 'Benin', dial_code: '+229' },
    { alpha2: 'BM', name: 'Bermuda', dial_code: '+1441' },
    { alpha2: 'BT', name: 'Bhutan', dial_code: '+975' },
    { alpha2: 'BO', name: 'Bolivia', dial_code: '+591' },
    { alpha2: 'BA', name: 'Bosnia and Herzegovina', dial_code: '+387' },
    { alpha2: 'BW', name: 'Botswana', dial_code: '+267' },
    { alpha2: 'BR', name: 'Brazil', dial_code: '+55' },
    { alpha2: 'BN', name: 'Brunei', dial_code: '+673' },
    { alpha2: 'BG', name: 'Bulgaria', dial_code: '+359' },
    { alpha2: 'BF', name: 'Burkina Faso', dial_code: '+226' },
    { alpha2: 'BI', name: 'Burundi', dial_code: '+257' },
    { alpha2: 'KH', name: 'Cambodia', dial_code: '+855' },
    { alpha2: 'CM', name: 'Cameroon', dial_code: '+237' },
    { alpha2: 'CA', name: 'Canada', dial_code: '+1' },
    { alpha2: 'CV', name: 'Cape Verde', dial_code: '+238' },
    { alpha2: 'KY', name: 'Cayman Islands', dial_code: '+1345' },
    { alpha2: 'CF', name: 'Central African Republic', dial_code: '+236' },
    { alpha2: 'TD', name: 'Chad', dial_code: '+235' },
    { alpha2: 'CL', name: 'Chile', dial_code: '+56' },
    { alpha2: 'CN', name: 'China', dial_code: '+86' },
    { alpha2: 'CO', name: 'Colombia', dial_code: '+57' },
    { alpha2: 'KM', name: 'Comoros', dial_code: '+269' },
    { alpha2: 'CG', name: 'Congo', dial_code: '+242' },
    { alpha2: 'CD', name: 'Congo (DRC)', dial_code: '+243' },
    { alpha2: 'CR', name: 'Costa Rica', dial_code: '+506' },
    { alpha2: 'CI', name: "Côte d'Ivoire", dial_code: '+225' },
    { alpha2: 'HR', name: 'Croatia', dial_code: '+385' },
    { alpha2: 'CU', name: 'Cuba', dial_code: '+53' },
    { alpha2: 'CY', name: 'Cyprus', dial_code: '+357' },
    { alpha2: 'CZ', name: 'Czech Republic', dial_code: '+420' },
    { alpha2: 'DK', name: 'Denmark', dial_code: '+45' },
    { alpha2: 'DJ', name: 'Djibouti', dial_code: '+253' },
    { alpha2: 'DM', name: 'Dominica', dial_code: '+1767' },
    { alpha2: 'DO', name: 'Dominican Republic', dial_code: '+1809' },
    { alpha2: 'EC', name: 'Ecuador', dial_code: '+593' },
    { alpha2: 'EG', name: 'Egypt', dial_code: '+20' },
    { alpha2: 'SV', name: 'El Salvador', dial_code: '+503' },
    { alpha2: 'GQ', name: 'Equatorial Guinea', dial_code: '+240' },
    { alpha2: 'ER', name: 'Eritrea', dial_code: '+291' },
    { alpha2: 'EE', name: 'Estonia', dial_code: '+372' },
    { alpha2: 'SZ', name: 'Eswatini', dial_code: '+268' },
    { alpha2: 'ET', name: 'Ethiopia', dial_code: '+251' },
    { alpha2: 'FJ', name: 'Fiji', dial_code: '+679' },
    { alpha2: 'FI', name: 'Finland', dial_code: '+358' },
    { alpha2: 'FR', name: 'France', dial_code: '+33' },
    { alpha2: 'GA', name: 'Gabon', dial_code: '+241' },
    { alpha2: 'GM', name: 'Gambia', dial_code: '+220' },
    { alpha2: 'GE', name: 'Georgia', dial_code: '+995' },
    { alpha2: 'DE', name: 'Germany', dial_code: '+49' },
    { alpha2: 'GH', name: 'Ghana', dial_code: '+233' },
    { alpha2: 'GR', name: 'Greece', dial_code: '+30' },
    { alpha2: 'GD', name: 'Grenada', dial_code: '+1473' },
    { alpha2: 'GT', name: 'Guatemala', dial_code: '+502' },
    { alpha2: 'GN', name: 'Guinea', dial_code: '+224' },
    { alpha2: 'GW', name: 'Guinea-Bissau', dial_code: '+245' },
    { alpha2: 'GY', name: 'Guyana', dial_code: '+592' },
    { alpha2: 'HT', name: 'Haiti', dial_code: '+509' },
    { alpha2: 'HN', name: 'Honduras', dial_code: '+504' },
    { alpha2: 'HK', name: 'Hong Kong', dial_code: '+852' },
    { alpha2: 'HU', name: 'Hungary', dial_code: '+36' },
    { alpha2: 'IS', name: 'Iceland', dial_code: '+354' },
    { alpha2: 'IN', name: 'India', dial_code: '+91' },
    { alpha2: 'ID', name: 'Indonesia', dial_code: '+62' },
    { alpha2: 'IR', name: 'Iran', dial_code: '+98' },
    { alpha2: 'IQ', name: 'Iraq', dial_code: '+964' },
    { alpha2: 'IE', name: 'Ireland', dial_code: '+353' },
    { alpha2: 'IL', name: 'Israel', dial_code: '+972' },
    { alpha2: 'IT', name: 'Italy', dial_code: '+39' },
    { alpha2: 'JM', name: 'Jamaica', dial_code: '+1876' },
    { alpha2: 'JP', name: 'Japan', dial_code: '+81' },
    { alpha2: 'JO', name: 'Jordan', dial_code: '+962' },
    { alpha2: 'KZ', name: 'Kazakhstan', dial_code: '+7' },
    { alpha2: 'KE', name: 'Kenya', dial_code: '+254' },
    { alpha2: 'KI', name: 'Kiribati', dial_code: '+686' },
    { alpha2: 'KW', name: 'Kuwait', dial_code: '+965' },
    { alpha2: 'KG', name: 'Kyrgyzstan', dial_code: '+996' },
    { alpha2: 'LA', name: 'Laos', dial_code: '+856' },
    { alpha2: 'LV', name: 'Latvia', dial_code: '+371' },
    { alpha2: 'LB', name: 'Lebanon', dial_code: '+961' },
    { alpha2: 'LS', name: 'Lesotho', dial_code: '+266' },
    { alpha2: 'LR', name: 'Liberia', dial_code: '+231' },
    { alpha2: 'LY', name: 'Libya', dial_code: '+218' },
    { alpha2: 'LI', name: 'Liechtenstein', dial_code: '+423' },
    { alpha2: 'LT', name: 'Lithuania', dial_code: '+370' },
    { alpha2: 'LU', name: 'Luxembourg', dial_code: '+352' },
    { alpha2: 'MO', name: 'Macao', dial_code: '+853' },
    { alpha2: 'MG', name: 'Madagascar', dial_code: '+261' },
    { alpha2: 'MW', name: 'Malawi', dial_code: '+265' },
    { alpha2: 'MY', name: 'Malaysia', dial_code: '+60' },
    { alpha2: 'MV', name: 'Maldives', dial_code: '+960' },
    { alpha2: 'ML', name: 'Mali', dial_code: '+223' },
    { alpha2: 'MT', name: 'Malta', dial_code: '+356' },
    { alpha2: 'MH', name: 'Marshall Islands', dial_code: '+692' },
    { alpha2: 'MR', name: 'Mauritania', dial_code: '+222' },
    { alpha2: 'MU', name: 'Mauritius', dial_code: '+230' },
    { alpha2: 'MX', name: 'Mexico', dial_code: '+52' },
    { alpha2: 'FM', name: 'Micronesia', dial_code: '+691' },
    { alpha2: 'MD', name: 'Moldova', dial_code: '+373' },
    { alpha2: 'MC', name: 'Monaco', dial_code: '+377' },
    { alpha2: 'MN', name: 'Mongolia', dial_code: '+976' },
    { alpha2: 'ME', name: 'Montenegro', dial_code: '+382' },
    { alpha2: 'MA', name: 'Morocco', dial_code: '+212' },
    { alpha2: 'MZ', name: 'Mozambique', dial_code: '+258' },
    { alpha2: 'MM', name: 'Myanmar', dial_code: '+95' },
    { alpha2: 'NA', name: 'Namibia', dial_code: '+264' },
    { alpha2: 'NR', name: 'Nauru', dial_code: '+674' },
    { alpha2: 'NP', name: 'Nepal', dial_code: '+977' },
    { alpha2: 'NL', name: 'Netherlands', dial_code: '+31' },
    { alpha2: 'NZ', name: 'New Zealand', dial_code: '+64' },
    { alpha2: 'NI', name: 'Nicaragua', dial_code: '+505' },
    { alpha2: 'NE', name: 'Niger', dial_code: '+227' },
    { alpha2: 'NG', name: 'Nigeria', dial_code: '+234' },
    { alpha2: 'KP', name: 'North Korea', dial_code: '+850' },
    { alpha2: 'MK', name: 'North Macedonia', dial_code: '+389' },
    { alpha2: 'NO', name: 'Norway', dial_code: '+47' },
    { alpha2: 'OM', name: 'Oman', dial_code: '+968' },
    { alpha2: 'PK', name: 'Pakistan', dial_code: '+92' },
    { alpha2: 'PW', name: 'Palau', dial_code: '+680' },
    { alpha2: 'PS', name: 'Palestine', dial_code: '+970' },
    { alpha2: 'PA', name: 'Panama', dial_code: '+507' },
    { alpha2: 'PG', name: 'Papua New Guinea', dial_code: '+675' },
    { alpha2: 'PY', name: 'Paraguay', dial_code: '+595' },
    { alpha2: 'PE', name: 'Peru', dial_code: '+51' },
    { alpha2: 'PH', name: 'Philippines', dial_code: '+63' },
    { alpha2: 'PL', name: 'Poland', dial_code: '+48' },
    { alpha2: 'PT', name: 'Portugal', dial_code: '+351' },
    { alpha2: 'PR', name: 'Puerto Rico', dial_code: '+1787' },
    { alpha2: 'QA', name: 'Qatar', dial_code: '+974' },
    { alpha2: 'RO', name: 'Romania', dial_code: '+40' },
    { alpha2: 'RU', name: 'Russia', dial_code: '+7' },
    { alpha2: 'RW', name: 'Rwanda', dial_code: '+250' },
    { alpha2: 'KN', name: 'Saint Kitts and Nevis', dial_code: '+1869' },
    { alpha2: 'LC', name: 'Saint Lucia', dial_code: '+1758' },
    { alpha2: 'VC', name: 'Saint Vincent and the Grenadines', dial_code: '+1784' },
    { alpha2: 'WS', name: 'Samoa', dial_code: '+685' },
    { alpha2: 'SM', name: 'San Marino', dial_code: '+378' },
    { alpha2: 'ST', name: 'São Tomé and Príncipe', dial_code: '+239' },
    { alpha2: 'SA', name: 'Saudi Arabia', dial_code: '+966' },
    { alpha2: 'SN', name: 'Senegal', dial_code: '+221' },
    { alpha2: 'RS', name: 'Serbia', dial_code: '+381' },
    { alpha2: 'SC', name: 'Seychelles', dial_code: '+248' },
    { alpha2: 'SL', name: 'Sierra Leone', dial_code: '+232' },
    { alpha2: 'SG', name: 'Singapore', dial_code: '+65' },
    { alpha2: 'SK', name: 'Slovakia', dial_code: '+421' },
    { alpha2: 'SI', name: 'Slovenia', dial_code: '+386' },
    { alpha2: 'SB', name: 'Solomon Islands', dial_code: '+677' },
    { alpha2: 'SO', name: 'Somalia', dial_code: '+252' },
    { alpha2: 'ZA', name: 'South Africa', dial_code: '+27' },
    { alpha2: 'KR', name: 'South Korea', dial_code: '+82' },
    { alpha2: 'SS', name: 'South Sudan', dial_code: '+211' },
    { alpha2: 'ES', name: 'Spain', dial_code: '+34' },
    { alpha2: 'LK', name: 'Sri Lanka', dial_code: '+94' },
    { alpha2: 'SD', name: 'Sudan', dial_code: '+249' },
    { alpha2: 'SR', name: 'Suriname', dial_code: '+597' },
    { alpha2: 'SE', name: 'Sweden', dial_code: '+46' },
    { alpha2: 'CH', name: 'Switzerland', dial_code: '+41' },
    { alpha2: 'SY', name: 'Syria', dial_code: '+963' },
    { alpha2: 'TW', name: 'Taiwan', dial_code: '+886' },
    { alpha2: 'TJ', name: 'Tajikistan', dial_code: '+992' },
    { alpha2: 'TZ', name: 'Tanzania', dial_code: '+255' },
    { alpha2: 'TH', name: 'Thailand', dial_code: '+66' },
    { alpha2: 'TL', name: 'Timor-Leste', dial_code: '+670' },
    { alpha2: 'TG', name: 'Togo', dial_code: '+228' },
    { alpha2: 'TO', name: 'Tonga', dial_code: '+676' },
    { alpha2: 'TT', name: 'Trinidad and Tobago', dial_code: '+1868' },
    { alpha2: 'TN', name: 'Tunisia', dial_code: '+216' },
    { alpha2: 'TR', name: 'Turkey', dial_code: '+90' },
    { alpha2: 'TM', name: 'Turkmenistan', dial_code: '+993' },
    { alpha2: 'TV', name: 'Tuvalu', dial_code: '+688' },
    { alpha2: 'UG', name: 'Uganda', dial_code: '+256' },
    { alpha2: 'UA', name: 'Ukraine', dial_code: '+380' },
    { alpha2: 'AE', name: 'United Arab Emirates', dial_code: '+971' },
    { alpha2: 'GB', name: 'United Kingdom', dial_code: '+44' },
    { alpha2: 'US', name: 'United States', dial_code: '+1' },
    { alpha2: 'UY', name: 'Uruguay', dial_code: '+598' },
    { alpha2: 'UZ', name: 'Uzbekistan', dial_code: '+998' },
    { alpha2: 'VU', name: 'Vanuatu', dial_code: '+678' },
    { alpha2: 'VE', name: 'Venezuela', dial_code: '+58' },
    { alpha2: 'VN', name: 'Vietnam', dial_code: '+84' },
    { alpha2: 'YE', name: 'Yemen', dial_code: '+967' },
    { alpha2: 'ZM', name: 'Zambia', dial_code: '+260' },
    { alpha2: 'ZW', name: 'Zimbabwe', dial_code: '+263' },
];
